import { ReactNode } from 'react'

interface ContainerProps {
    children?: ReactNode
}

import styles from './Container.module.css';

export const Container = ({ children }: ContainerProps) => {
    return (
        <div className={styles.container}>
            { children }
        </div>
    )
}